import React, { useEffect, type ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';
import { hasLogoutStarted, setAuthErrorHandler } from '@/auth/session';

interface Props {
  children: ReactNode;
}

let isForceLogoutRunning = false;

export const ForceLogoutBridge: React.FC<Props> = ({ children }) => {
  const { removeUser, signinRedirect } = useAuth();

  useEffect(() => {
    const forceLogout = async () => {
      if (isForceLogoutRunning || hasLogoutStarted()) {
        return;
      }

      isForceLogoutRunning = true;

      try {
        await removeUser();
        await signinRedirect();
      } catch (error) {
        isForceLogoutRunning = false;
        throw error;
      }
    };

    setAuthErrorHandler(forceLogout);

    return () => {
      setAuthErrorHandler(undefined);
    };
  }, [removeUser, signinRedirect]);

  return <>{children}</>;
};
